import React from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";

const UserActionDropdown = ({
  onViewDetails,
  onManageUser,
  tempRemoval,
  border = "border-none shadow-none",
}) => {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <MenuButton
        className={`inline-flex items-center justify-center rounded-md p-1.5 text-gray-400 hover:text-gray-500 hover:bg-gray-50 focus:outline-none ${border}`}
      >
        <span className="sr-only">Open options</span>
        <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
      </MenuButton>

      <MenuItems
        anchor="bottom end"
        portal
        className="z-[100] mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
      >
        <div className="py-1">
          {tempRemoval ? null : (
            <MenuItem>
              {({ active }) => (
                <button
                  type="button"
                  onClick={onViewDetails}
                  className={`block w-full px-4 py-2 text-left text-sm ${
                    active ? "bg-gray-100 text-gray-900" : "text-gray-700"
                  }`}
                >
                  View Details
                </button>
              )}
            </MenuItem>
          )}

          <MenuItem>
            {({ active }) => (
              <button
                type="button"
                onClick={onManageUser}
                className={`block w-full px-4 py-2 text-left text-sm ${
                  active ? "bg-gray-100 text-gray-900" : "text-gray-700"
                }`}
              >
                Manage User
              </button>
            )}
          </MenuItem>
        </div>
      </MenuItems>
    </Menu>
  );
};

export default UserActionDropdown;
